class ChildContractTypeEnum {
    static Bowe = 'bowe';
}

export default ChildContractTypeEnum;